import { createIcon } from "@chakra-ui/icons";

export default createIcon({
  displayName: "Parks",
  viewBox: "0 0 448 512",
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 30 30"
      focusable="false"
    >
      <circle cx={15} cy={15} r={14} fill="url(#a)" />
      <g clipPath="url(#b)">
        <path
          fill="#fff"
          d="M23.1 10.7c0 .143-.011.287-.034.425A2.251 2.251 0 0 1 21.75 15.2h-.45v6.3a.899.899 0 1 1-1.8 0v-6.3h-.45a2.25 2.25 0 0 1-1.316-4.075A2.7 2.7 0 1 1 23.1 10.7ZM6.9 14.3c0-.498.402-.9.9-.9H15c.498 0 .9.402.9.9v1.8c0 .498-.402.9-.9.9H7.8a.899.899 0 0 1-.9-.9v-1.8Zm0 3.6h9a.899.899 0 1 1 0 1.8v1.8a.899.899 0 1 1-1.8 0v-1.8H8.7v1.8a.899.899 0 1 1-1.8 0v-1.8a.899.899 0 1 1 0-1.8Z"
        />
      </g>
      <defs>
        <linearGradient
          id="a"
          x1={1}
          x2={29.645}
          y1={9.54}
          y2={12.084}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#52EE4F" />
          <stop offset={1} stopColor="#059700" />
        </linearGradient>
        <clipPath id="b">
          <path fill="#fff" d="M6 8h18v14.4H6z" />
        </clipPath>
      </defs>
    </svg>
  ),
});
